export default {
  editEquipmentDetails: 'Edytuj szczegóły urządzenia',
  certificate: {
    pyrometry: 'AMS2750',
    furnaceClass: 'Klasa pieca {value}',
    instrumentationType: 'Typ instrumentacji {value}',
    heatTreatment: 'AMS2759',
  },
  capability: {
    gasChip: '{name} - {maxFlow} l/min',
  },
  capacity: {
    minTemp: 'Minimalna temperatura',
    maxTemp: 'Maksymalna temperatura',
    dimensions: 'Wymiary',
    maxLoad: 'Maksymalne obciążenie',
    concurrentJobLimit: 'Maks. liczba jednoczesnych zadań: {value}',
  },
  statistic: {
    targetProductivity: 'Docelowa produktywność',
  },
};
